<template>
	<div id="app">
		<router-view />
		<Dialogs ref="dialogs"></Dialogs>
	</div>
</template>
<script>
	import Dialogs from '@/components/Dialogs.vue'
	export default {
		components: {
			Dialogs,
		},
		mounted() {


			window.dialogs = this.$refs.dialogs;




			window.Message = {

				msg: (message) => {
					this.$message({
						message,
					})
				},

				success: (message) => {
					this.$message({
						message: message || '操作成功',
						type: 'success'
					})
				},

				error: (message) => {
					this.$message({
						message,
						type: 'error'
					})
				},

				warning: (message) => {
					this.$message({
						message,
						type: 'warning'
					})
				}



			};
			// window.Loading = {
			// 	open: () => {
			// 		clearTimeout(window.Loading.timer);
			// 		window.Loading.loading = this.$loading({
			// 			lock: true,
			// 			text: 'Loading',
			// 			spinner: 'el-icon-loading',
			// 			background: 'rgba(0, 0, 0, 0.7)'
			// 		});
			// 		window.Loading.timer = setTimeout(() => {
			// 			window.Loading.close();
			// 		}, 10000)
			// 	},
			// 	close: () => {
			// 		if (!window.Loading.loading) return;
			// 		window.Loading.loading.close();
			// 		window.Loading.loading = null;
			// 	}
			// }

		}
	}
</script>
<style lang="scss">
	@import url("./base.css");
	@import url("./sm.css");

	* {
		box-sizing: border-box;

	}

	body {
		font-family: Alata, PingFang SC, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;

	}



	html,
	body {
		user-select: auto !important;
		margin: 0;
		padding: 0;
		overflow-x: hidden;
		background-color: #f4f4f2;
		color: #282622;
	}

	.mt-19 {
		margin-top: 190px;
	}



	.oh {
		overflow: hidden;
	}

	.oa {
		overflow: auto;
	}

	.oxh {
		overflow-x: hidden;
	}



	.oya {
		overflow-y: auto;
	}

	.bg-image {
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
	}





	.input-none {
		background-color: rgba(0, 0, 0, 0);
		border: none;
		outline: none;
	}

	.br {
		border-radius: 15px;
	}

	.br-sm {
		border-radius: 5px;
	}

	.br-lg {
		border-radius: 25px;
	}

	.br-full {
		border-radius: 100%;
	}



	.page {
		letter-spacing: 1px;
		user-select: auto;
		font-size: 14px;
		background-color: #f5f5f5;
		box-sizing: border-box;
		// color: #333333;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 100vw;
		/* max-width: 1200px; */
		/* font-family: "PingFang SC", "system-ui", Helvetica, Tahoma, Arial, "Microsoft YaHei", 微软雅黑, 黑体, Heiti, sans-serif, SimSun, 宋体, serif; */


		/* background-image: url('@/static/bg.webp');
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover; */

	}


	.main {
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		max-width: 1200px;
	}

	.main2 {
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		max-width: 750px;
	}

	.main3 {
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		max-width: 400px;
	}



	.cm-0-5>* {
		margin: 5px;
	}


	.cm-1>* {
		margin: 10px;
	}


	.cm-2>* {
		margin: 20px;
	}


	.cm-3>* {
		margin: 30px;
	}


	.cm-0-5>*:not(:first-child) {
		margin: 5px;
	}


	.cmt-1>*:not(:first-child) {
		margin-top: 10px;
	}


	.cmt-2>*:not(:first-child) {
		margin-top: 20px;
	}


	.cmt-3>*:not(:first-child) {
		margin-top: 30px;
	}



	.cml-1>*:not(:first-child) {
		margin-left: 10px;
	}

	.cml-2>*:not(:first-child) {
		margin-left: 20px;
	}

	.cml-3>*:not(:first-child) {
		margin-left: 30px;
	}

	.cml-4>*:not(:first-child) {
		margin-left: 40px;
	}

	.cml-5>*:not(:first-child) {
		margin-left: 50px;
	}

	.card {
		position: relative;
		margin-top: 10px;
		margin-left: 10px;
		margin-right: 10px;
		background-color: white;
		border-radius: 6px;
	}

	.el-form-item__label {
		font-weight: bolder;
	}



	/* latin-ext */
	@font-face {
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 400;
		font-display: swap;
		src: url(https://fonts.gstatic.com/s/dmsans/v17/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu6-K6h9Q.woff2) format('woff2');
		unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}

	/* latin */
	@font-face {
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 400;
		font-display: swap;
		src: url(https://fonts.gstatic.com/s/dmsans/v17/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu0-K4.woff2) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}

	/* latin-ext */
	@font-face {
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 500;
		font-display: swap;
		src: url(https://fonts.gstatic.com/s/dmsans/v17/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu6-K6h9Q.woff2) format('woff2');
		unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}

	/* latin */
	@font-face {
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 500;
		font-display: swap;
		src: url(https://fonts.gstatic.com/s/dmsans/v17/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu0-K4.woff2) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}

	/* latin-ext */
	@font-face {
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 700;
		font-display: swap;
		src: url(https://fonts.gstatic.com/s/dmsans/v17/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu6-K6h9Q.woff2) format('woff2');
		unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}

	/* latin */
	@font-face {
		font-family: 'DM Sans';
		font-style: normal;
		font-weight: 700;
		font-display: swap;
		src: url(https://fonts.gstatic.com/s/dmsans/v17/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu0-K4.woff2) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}

	.ff2 {
		font-family: 'DM Sans', Alata, PingFang SC, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif !important;

	}

	// .lang-ja-JP .ff2 {
	// 	font-family: 'Noto Sans JP', 'DM Sans', Alata, PingFang SC, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;
	// }



	// .lang-ja-JP * {
	// 	font-family: 'Zen Kaku Gothic Antique', Alata, PingFang SC, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;

	// }


	.ff-Noto-Sans-JP {
		font-family: 'Noto Sans JP' !important;
	}




	input {
		height: 48px !important;
	}

	/* 选中文本的前景色（文字颜色）和背景色 */
	::selection {
		color: #fff;
		/* 选中后的文字颜色 */
		background-color: #3498db;
		/* 选中后的背景色 */
	}

	/* 兼容旧版浏览器（如 Safari 8 及以下） */
	::-moz-selection {
		color: #fff;
		background-color: #3498db;
	}
</style>